export function GenerateRandomString() {
  return Math.random().toString(36).substring(7);
}
